import { N0CheckinDocCheckResponse, N0CheckinResponse, N0CheckinStatus } from '@models/check-in.models';
import { createAction, props } from '@ngrx/store';

export const enum CheckInActionTypes {
  autoAssignSeatsSuccess = '[check-in] AUTO_ASSIGN_SEATS_SUCCESS',
  checkInPassengers = '[check-in] CHECK_IN_PASSENGERS',
  checkInPassengersSuccess = '[check-in] CHECK_IN_PASSENGERS_SUCCESS',
  getCheckInStatus = '[check-in] GET_CHECK_IN_STATUS',
  getCheckInStatusSuccess = '[check-in] GET_CHECK_IN_STATUS_SUCCESS',
  checkInDocCheck = '[check-in] CHECK_IN_DOC_CHECK',
  checkInDocCheckSuccess = '[check-in] CHECK_IN_DOC_CHECK_SUCCESS',
  checkInDocCheckReset = '[check-in] CHECK_IN_DOC_CHECK_RESET',
}

export const checkInAutoAssignSeatsSuccess = createAction(
  CheckInActionTypes.autoAssignSeatsSuccess,
);

export const checkInCheckInPassengers = createAction(
  CheckInActionTypes.checkInPassengers,
  props<{ navigate: boolean }>(),
);

export const checkInCheckInPassengersSuccess = createAction(
  CheckInActionTypes.checkInPassengersSuccess,
  props<{ payload: N0CheckinResponse; navigate: boolean }>(),
);

export const checkInGetCheckInStatus = createAction(
  CheckInActionTypes.getCheckInStatus,
);

export const checkInGetCheckInStatusSuccess = createAction(
  CheckInActionTypes.getCheckInStatusSuccess,
  props<{ payload: N0CheckinStatus[] }>(),
);

export const checkInDocCheck = createAction(
  CheckInActionTypes.checkInDocCheck,
)

export const checkInDocCheckSuccess = createAction(
  CheckInActionTypes.checkInDocCheckSuccess,
  props<{ payload: N0CheckinDocCheckResponse }>(),
)

export const checkInDocCheckReset = createAction(
  CheckInActionTypes.checkInDocCheckReset,
)